import httpService from "./httpService";
import utils from "./utils";

export default {
  findById(id) {
    return httpService.get("vbStep/" + id);
  },

  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    var params = utils.merge(example, pageable);

    return httpService.get("vbStep", { params: params });
  },

  getPreStepByVbIncomingProcessId(vbIncomingProcessId) {
    const params = {vbIncomingProcessId: vbIncomingProcessId};
    return httpService.get("vbStep/getPreStepByVbIncomingProcessId", {params: params});
  }
};



// WEBPACK FOOTER //
// ./src/services/vbStepService.js